var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _path10, _g4, _g5, _g6, _path11, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrand = function SvgBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.652 223.891"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h164.198v98.494H0z",
    "data-name": "Rectangle 3065"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h29.74v22.602H0z",
    "data-name": "Rectangle 2994"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h8.87v7.729H0z",
    "data-name": "Rectangle 3001"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h47.071v21.481H0z",
    "data-name": "Rectangle 3002"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h46.198v18.859H0z",
    "data-name": "Rectangle 3003"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h21.26v4.251H0z",
    "data-name": "Rectangle 3004"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1.584v1.417H0z",
    "data-name": "Rectangle 3006"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.608v5.559H0z",
    "data-name": "Rectangle 3007"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.335v5.152H0z",
    "data-name": "Rectangle 3008"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h2.208v6.331H0z",
    "data-name": "Rectangle 3009"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h5.609v31.322H0z",
    "data-name": "Rectangle 3010"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4.637v29.238H0z",
    "data-name": "Rectangle 3011"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__n"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16.586v11.486H0z",
    "data-name": "Rectangle 3014"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__o"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16.368v8.917H0z",
    "data-name": "Rectangle 3015"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__p"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20.373v20.373H0z",
    "data-name": "Rectangle 3016"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__q"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h8.663v12.208H0z",
    "data-name": "Rectangle 3026"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__r"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h12.11v11.368H0z",
    "data-name": "Rectangle 3038"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__s"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h12.111v11.368H0z",
    "data-name": "Rectangle 3042"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__t"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h11.991v7.904H0z",
    "data-name": "Rectangle 3050"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__u"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h11.992v7.904H0z",
    "data-name": "Rectangle 3052"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__v"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20.289v20.289H0z",
    "data-name": "Rectangle 3057"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__w"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h7.757v7.106H0z",
    "data-name": "Rectangle 3058"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__x"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h8.037v1.359H0z",
    "data-name": "Rectangle 3060"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__y"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h11.681v7.081H0z",
    "data-name": "Rectangle 3062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "brand_svg__z"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h3.298v3.368H0z",
    "data-name": "Rectangle 3063"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "brand_svg__a",
    width: 229.652,
    height: 223.891,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10039"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    className: "brand_svg__svg-stoke",
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.856 189.527a81.6 81.6 0 0 1-16.318-1.644 80.6 80.6 0 0 1-15.198-4.718 81 81 0 0 1-13.753-7.465 81.6 81.6 0 0 1-11.983-9.887 81.6 81.6 0 0 1-9.887-11.983 81 81 0 0 1-7.465-13.753 80.6 80.6 0 0 1-4.717-15.197 81.6 81.6 0 0 1-1.645-16.318c0-8.606 2.396-19.11 6.93-30.377 4.563-11.341 10.982-22.675 18.564-32.774 3.967-5.284 8.198-10.152 12.577-14.47 4.607-4.542 9.382-8.478 14.193-11.697 5.09-3.406 10.26-6.036 15.367-7.816 5.415-1.888 10.833-2.845 16.106-2.845 12.936 0 25.177 5.682 36.384 16.889 12.652 12.652 22.266 23.309 29.392 32.58 3.542 4.607 6.481 8.872 8.988 13.039 2.423 4.03 4.38 7.866 5.983 11.73 6.247 15.06 6.116 28.466 5.936 47.02-.033 3.318-.066 6.748-.066 10.405 0 20.227-9.08 33.736-27.76 41.3-7.742 3.134-17.116 5.271-28.657 6.533-9.037.988-19.514 1.448-32.971 1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M104.627 9.083c-5.216 0-10.58.948-15.942 2.817-5.067 1.766-10.199 4.377-15.253 7.76-4.785 3.201-9.535 7.117-14.12 11.638-4.361 4.3-8.576 9.15-12.528 14.413-7.556 10.065-13.953 21.36-18.5 32.66-2.22 5.516-3.938 10.893-5.107 15.982-1.186 5.16-1.787 9.941-1.787 14.209 0 5.46.55 10.917 1.635 16.218a80 80 0 0 0 4.688 15.102 80.5 80.5 0 0 0 7.419 13.668 81 81 0 0 0 9.826 11.91 81 81 0 0 0 11.91 9.826 80.5 80.5 0 0 0 13.667 7.418 80 80 0 0 0 15.103 4.689 81 81 0 0 0 16.218 1.634c13.438 0 23.898-.459 32.917-1.445 11.494-1.257 20.824-3.383 28.524-6.5 4.255-1.723 8.051-3.783 11.282-6.123 3.416-2.473 6.322-5.347 8.637-8.54 2.439-3.365 4.307-7.2 5.552-11.4 1.311-4.422 1.976-9.393 1.976-14.773 0-3.659.033-7.09.066-10.41.18-18.494.31-31.857-5.898-46.824-1.593-3.84-3.539-7.655-5.95-11.663-2.496-4.15-5.426-8.4-8.955-12.993-7.113-9.253-16.713-19.894-29.35-32.53-11.11-11.11-23.231-16.743-36.03-16.743m0-1c12.206 0 24.704 5.002 36.737 17.035 55.474 55.474 50.38 70.136 50.38 115.128s-44.896 49.781-89.888 49.781-81.466-36.473-81.466-81.465c0-35.233 40.173-100.479 84.237-100.479"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#brand_svg__a)",
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.883 22.501c31.657 0 52.156 17.307 68.756 48.136 10.476 19.454 31.305 46.53 30.489 72.753-2.081 66.893-99.225 61.031-130.147 53.774S9.086 147.501 27.36 102.859s28.455-80.358 80.523-80.358",
    "data-name": "Path 16564"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9974"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9973",
    transform: "translate(30.39 64.363)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9862"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9861"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M93.962 83.376a7 7 0 0 1 1.7-.727l.35-1.656 2.842-.049.409 1.642a7 7 0 0 1 1.725.668l1.437-.927 2.037 1.94-.891 1.445a6.8 6.8 0 0 1 .739 1.673l1.682.344.05 2.8-1.669.4a6.8 6.8 0 0 1-.678 1.7l.941 1.414-1.974 2.013-1.469-.876a7 7 0 0 1-1.7.727l-.35 1.656-2.842.049-.409-1.643a7 7 0 0 1-1.725-.668l-1.437.927-2.045-1.944.891-1.445a6.8 6.8 0 0 1-.739-1.673l-1.682-.345-.05-2.8 1.669-.4a6.8 6.8 0 0 1 .679-1.7l-.941-1.414 1.974-2.013Zm1.808 3.464a2.975 2.975 0 0 0 .086 4.761 3.086 3.086 0 0 0 3.715-.065 2.975 2.975 0 0 0-.086-4.762 3.086 3.086 0 0 0-3.715.066",
    "data-name": "Path 15923"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M111.339 82.373a4.4 4.4 0 0 1 1.068-.457l.22-1.041 1.787-.031.257 1.032a4.4 4.4 0 0 1 1.084.42l.9-.583 1.286 1.222-.56.908a4.3 4.3 0 0 1 .464 1.052l1.057.217.031 1.758-1.049.253a4.3 4.3 0 0 1-.427 1.067l.592.889-1.241 1.265-.923-.551a4.4 4.4 0 0 1-1.069.457l-.22 1.041-1.787.031-.257-1.032a4.4 4.4 0 0 1-1.084-.42l-.9.583-1.286-1.222.56-.909a4.3 4.3 0 0 1-.464-1.052l-1.057-.217-.033-1.76 1.049-.253a4.3 4.3 0 0 1 .427-1.067l-.592-.889 1.241-1.265Zm1.137 2.177a1.87 1.87 0 0 0 .054 2.993 1.94 1.94 0 0 0 2.335-.041 1.87 1.87 0 0 0-.054-2.993 1.94 1.94 0 0 0-2.335.041",
    "data-name": "Path 15924"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M152.811 61.467a4.4 4.4 0 0 1 1.068-.457l.22-1.041 1.787-.031.257 1.032a4.4 4.4 0 0 1 1.084.42l.9-.583 1.286 1.222-.56.909a4.3 4.3 0 0 1 .464 1.052l1.057.217.032 1.758-1.049.253a4.3 4.3 0 0 1-.426 1.067l.592.889-1.241 1.265-.923-.551a4.4 4.4 0 0 1-1.069.457l-.22 1.041-1.787.031-.257-1.032a4.4 4.4 0 0 1-1.084-.42l-.9.583-1.285-1.219.56-.908a4.3 4.3 0 0 1-.464-1.052l-1.058-.217-.031-1.759 1.049-.253a4.3 4.3 0 0 1 .427-1.067l-.592-.889 1.241-1.265Zm1.137 2.177a1.87 1.87 0 0 0 .054 2.993 1.94 1.94 0 0 0 2.335-.041 1.87 1.87 0 0 0-.054-2.993 1.94 1.94 0 0 0-2.335.041",
    "data-name": "Path 15925"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M113.519 17.102a3.5 3.5 0 0 1 .85-.364l.175-.829 1.422-.025.2.822a3.5 3.5 0 0 1 .863.334l.719-.464 1.023.972-.445.723a3.4 3.4 0 0 1 .37.837l.842.173.025 1.4-.835.2a3.4 3.4 0 0 1-.34.849l.471.708-.988 1.007-.735-.438a3.5 3.5 0 0 1-.851.364l-.175.829-1.422.025-.2-.822a3.5 3.5 0 0 1-.863-.334l-.719.464-1.023-.972.445-.723a3.4 3.4 0 0 1-.37-.837l-.842-.172-.025-1.4.835-.2a3.4 3.4 0 0 1 .34-.849l-.471-.707.988-1.007Zm.9 1.733a1.49 1.49 0 0 0 .043 2.383 1.544 1.544 0 0 0 1.859-.032 1.49 1.49 0 0 0-.043-2.383 1.544 1.544 0 0 0-1.859.033",
    "data-name": "Path 15926"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M136.086 15.752a8 8 0 0 1 1.912-.818l.394-1.863 3.2-.055.46 1.848a8 8 0 0 1 1.94.751l1.616-1.043 2.3 2.187-1 1.626a7.6 7.6 0 0 1 .828 1.886l1.892.388.056 3.147-1.878.453a7.6 7.6 0 0 1-.763 1.909l1.059 1.591-2.221 2.265-1.652-.986a8 8 0 0 1-1.912.818l-.394 1.863-3.2.055-.46-1.848a8 8 0 0 1-1.94-.751l-1.616 1.043-2.3-2.186 1-1.626a7.6 7.6 0 0 1-.831-1.882l-1.893-.388-.056-3.147 1.877-.453a7.7 7.7 0 0 1 .763-1.909l-1.059-1.59 2.221-2.265Zm2.034 3.9a3.347 3.347 0 0 0 .1 5.356 3.47 3.47 0 0 0 4.179-.073 3.347 3.347 0 0 0-.1-5.357 3.47 3.47 0 0 0-4.179.074",
    "data-name": "Path 15927"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M4.02 70.604a5.8 5.8 0 0 1 1.409-.6l.29-1.372 2.356-.041.339 1.361a5.8 5.8 0 0 1 1.43.554l1.191-.768 1.7 1.611-.738 1.2a5.6 5.6 0 0 1 .603 1.38l1.394.286.042 2.319-1.383.334a5.6 5.6 0 0 1-.562 1.407l.781 1.172-1.637 1.669-1.217-.727a5.8 5.8 0 0 1-1.409.6l-.29 1.373-2.356.041-.339-1.362a5.8 5.8 0 0 1-1.429-.554l-1.191.768-1.7-1.611.738-1.2a5.6 5.6 0 0 1-.612-1.387l-1.394-.286L0 74.459l1.383-.334a5.6 5.6 0 0 1 .562-1.407l-.781-1.172L2.8 69.877Zm1.5 2.871a2.466 2.466 0 0 0 .071 3.947 2.56 2.56 0 0 0 3.08-.054A2.466 2.466 0 0 0 8.6 73.42a2.56 2.56 0 0 0-3.08.054",
    "data-name": "Path 15928"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M10.557 42.823a4 4 0 0 1 .973-.416l.2-.948 1.627-.028.234.94a4 4 0 0 1 .987.382l.822-.53 1.17 1.112-.51.827a3.9 3.9 0 0 1 .423.958l.963.2.028 1.6-.955.23a4 4 0 0 1-.388.971l.539.809-1.13 1.152-.841-.5a4 4 0 0 1-.973.416l-.2.948-1.626.028-.234-.94a4 4 0 0 1-.987-.382l-.822.53-1.17-1.112.51-.827a4 4 0 0 1-.423-.958l-.963-.2-.028-1.6.955-.23a4 4 0 0 1 .388-.971l-.539-.809 1.13-1.152Zm1.035 1.982a1.7 1.7 0 0 0 .049 2.725 1.766 1.766 0 0 0 2.126-.037 1.7 1.7 0 0 0-.049-2.725 1.766 1.766 0 0 0-2.126.038",
    "data-name": "Path 15929"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M46.992 38.055a2.7 2.7 0 0 1 .642-.274l.132-.625 1.073-.019.154.62a2.7 2.7 0 0 1 .651.252l.542-.35.772.734-.336.545a2.6 2.6 0 0 1 .279.632l.635.13.019 1.056-.63.152a2.6 2.6 0 0 1-.256.641l.355.534-.745.76-.555-.331a2.7 2.7 0 0 1-.642.274l-.132.625-1.073.018-.155-.62a2.7 2.7 0 0 1-.651-.252l-.542.35-.772-.734.336-.546a2.6 2.6 0 0 1-.279-.632l-.635-.13-.019-1.056.63-.152a2.6 2.6 0 0 1 .256-.641l-.355-.534.745-.76Zm.682 1.308a1.123 1.123 0 0 0 .032 1.8 1.165 1.165 0 0 0 1.4-.025 1.123 1.123 0 0 0-.032-1.8 1.165 1.165 0 0 0-1.4.025",
    "data-name": "Path 15930"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M120.453 26.79 95.115 61.636l60.184-9.507Zm1.318 8.345 18.7 13.6-32.294 5.1Z",
    "data-name": "Path 15931"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9857",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ebebeb",
    clipPath: "url(#brand_svg__c)",
    "data-name": "Group 9855",
    transform: "translate(121.913 28.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.965 2.069-.15-.109.839-1.154.15.109Z",
    "data-name": "Path 15932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.91 2.756-.151-.109.839-1.154.15.109Z",
    "data-name": "Path 15933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.062 4.318-.151-.109.839-1.155.151.109Z",
    "data-name": "Path 15934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.007 5.005-.15-.109.838-1.155.15.109Z",
    "data-name": "Path 15935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.163 6.568-.15-.109.839-1.155.15.109Z",
    "data-name": "Path 15936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.105 7.253-.151-.109.839-1.154.15.109Z",
    "data-name": "Path 15937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.257 8.817-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.202 9.503-.15-.109.838-1.155.15.109Z",
    "data-name": "Path 15939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.354 11.066-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.299 11.752-.15-.109.838-1.154.151.109Z",
    "data-name": "Path 15941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.451 13.315-.15-.109.838-1.155.15.109Z",
    "data-name": "Path 15942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.396 14.001-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.574 15.583-.15-.109.838-1.155.15.109Z",
    "data-name": "Path 15944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.519 16.269-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.684 17.841-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15946"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.629 18.53-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.845 20.137-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.79 20.823-.15-.109.838-1.155.15.109Z",
    "data-name": "Path 15949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.204 2.274-.2-.148L1.548 0l.2.148Z",
    "data-name": "Path 15950"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.314 4.533-.2-.148 1.544-2.126.2.148Z",
    "data-name": "Path 15951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.424 6.791-.2-.148 1.543-2.126.2.148Z",
    "data-name": "Path 15952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.535 9.05-.2-.148 1.544-2.126.2.148Z",
    "data-name": "Path 15953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.645 11.309-.2-.148 1.544-2.127.2.148Z",
    "data-name": "Path 15954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.755 13.568-.2-.148 1.544-2.127.2.148Z",
    "data-name": "Path 15955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.661 15.677 1.547-2.124.204.148-1.547 2.124z",
    "data-name": "Rectangle 2992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.771 17.936 1.547-2.124.204.148-1.547 2.124z",
    "data-name": "Rectangle 2993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.086 20.343-.2-.148 1.544-2.126.2.148Z",
    "data-name": "Path 15956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.196 22.602-.2-.148 1.543-2.126.2.148Z",
    "data-name": "Path 15957"
  }))))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M32.2 63.646 6.862 98.495l60.184-9.507Zm1.318 8.345 18.7 13.6-32.294 5.1Z",
    "data-name": "Path 15958"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9860",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ebebeb",
    clipPath: "url(#brand_svg__c)",
    "data-name": "Group 9858",
    transform: "translate(33.66 65.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.965 2.069-.15-.109.839-1.154.15.109Z",
    "data-name": "Path 15959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.91 2.755-.151-.109.839-1.154.151.109Z",
    "data-name": "Path 15960"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.062 4.314-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.011 5.005-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.16 6.568-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.104 7.253-.151-.109.839-1.154.151.109Z",
    "data-name": "Path 15964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.256 8.817-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.202 9.503-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.354 11.066-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.299 11.752-.15-.109.838-1.154.151.109Z",
    "data-name": "Path 15968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.451 13.315-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.396 14.002-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.575 15.583-.15-.109.838-1.155.15.109Z",
    "data-name": "Path 15971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.52 16.27-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.685 17.841-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.629 18.527-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.844 20.137-.15-.109.838-1.155.151.109Z",
    "data-name": "Path 15975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.79 20.823-.151-.109.839-1.155.15.109Z",
    "data-name": "Path 15976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.001 2.125 1.544.001l.204.148L.203 2.273z",
    "data-name": "Rectangle 2995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.314 4.533-.2-.148 1.544-2.126.2.148Z",
    "data-name": "Path 15977"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.425 6.791-.2-.148 1.543-2.126.2.148Z",
    "data-name": "Path 15978"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.535 9.05-.2-.148 1.544-2.126.2.148Z",
    "data-name": "Path 15979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.44 11.159 1.547-2.124.204.148-1.547 2.124z",
    "data-name": "Rectangle 2996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.55 13.418 1.547-2.124.204.148-1.547 2.124z",
    "data-name": "Rectangle 2997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.866 15.827-.2-.148 1.54-2.125.2.148Z",
    "data-name": "Path 15980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.771 17.936 1.548-2.123.204.148-1.548 2.123z",
    "data-name": "Rectangle 2998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.086 20.343-.2-.148 1.544-2.126.2.148Z",
    "data-name": "Path 15981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.197 22.602-.2-.148 1.543-2.126.2.148Z",
    "data-name": "Path 15982"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9876"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9875"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M59.67 95.453a4.218 4.218 0 1 1 5.607 2.037 4.22 4.22 0 0 1-5.607-2.037",
    "data-name": "Path 15983"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m8.837 72.531 5.547 6.324 45.889 18.06 2.929-7.958L17.579 71.07l-8.5.84a.393.393 0 0 0-.242.617",
    "data-name": "Path 15984"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9865",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9864"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__d)",
    "data-name": "Group 9863",
    transform: "translate(8.787 71.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.792-.005a.7.7 0 0 1-.519.844 1.88 1.88 0 0 1 .5 2 2.03 2.03 0 0 1-1.559 1.43 2.46 2.46 0 0 1-.009 2.165 2.27 2.27 0 0 1-1.657 1.3L.083 1.495A.42.42 0 0 1 .342.834Z",
    "data-name": "Path 15985"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M10.964 74.679c.415-.191 1.38-.848 1.205-2.782a.263.263 0 0 0-.28-.261l-2.846.281a.374.374 0 0 0-.23.587l1.856 2.117a.244.244 0 0 0 .294.059",
    "data-name": "Path 15986"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9868",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9867"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__e)",
    "data-name": "Group 9866",
    transform: "translate(14.339 75.343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.666 0 45.4 17.585-1.344 3.9L.045 3.511 0 3.459a1.8 1.8 0 0 0 .811-.31A2.57 2.57 0 0 0 1.899.724a2.1 2.1 0 0 0-.233-.725",
    "data-name": "Path 15987"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9871",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9870"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__f)",
    "data-name": "Group 9869",
    transform: "translate(17.061 71.074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .844 45.765 18.86l.434-.962L.519-.005a.77.77 0 0 1-.385.814.6.6 0 0 1-.134.03",
    "data-name": "Path 15988"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.008 75.759a.12.12 0 0 0 .094.025.25.25 0 0 0 .187-.238.85.85 0 0 0-.138-.477.4.4 0 0 0-.216-.175.3.3 0 0 0-.3.076.58.58 0 0 0-.143.37 1.7 1.7 0 0 0 .034.435 2.2 2.2 0 0 0 .336.848.44.44 0 0 0 .37.213.55.55 0 0 0 .4-.294 1.67 1.67 0 0 0 .091-1.13 1.6 1.6 0 0 0-1.322-1.318.5.5 0 0 0-.4.19 1.2 1.2 0 0 0-.213.428 3.4 3.4 0 0 0-.124.861 3.3 3.3 0 0 0 .194 1.19q.076.194.126.29c.05.096.048.1.048.1a2 2 0 0 1-.191-.378 3.2 3.2 0 0 1-.212-1.2 3.4 3.4 0 0 1 .121-.876 1.3 1.3 0 0 1 .223-.451.54.54 0 0 1 .433-.21 1.63 1.63 0 0 1 1.365 1.35 2.3 2.3 0 0 1 .053.593 1.3 1.3 0 0 1-.153.584.6.6 0 0 1-.44.322.48.48 0 0 1-.4-.231 2.25 2.25 0 0 1-.34-.87 1.7 1.7 0 0 1-.032-.449.63.63 0 0 1 .161-.4.33.33 0 0 1 .332-.082.42.42 0 0 1 .227.19.87.87 0 0 1 .134.5.264.264 0 0 1-.206.249.09.09 0 0 1-.094-.036",
    "data-name": "Path 15989"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.766 71.538c.006 0-.013.119 0 .327a2.2 2.2 0 0 0 .224.813 4.7 4.7 0 0 0 .672.978 4.2 4.2 0 0 1 .79 1.241 3.1 3.1 0 0 1 .1 1.6 3.4 3.4 0 0 1-.53 1.257 3 3 0 0 1-.608.657 2 2 0 0 1-.261.179 1 1 0 0 1 .065-.051q.067-.046.185-.146a3.2 3.2 0 0 0 .591-.662 3.3 3.3 0 0 0 .512-1.239 3.06 3.06 0 0 0-.1-1.568 4.2 4.2 0 0 0-.779-1.23 4.6 4.6 0 0 1-.669-.994 2.2 2.2 0 0 1-.212-.831 1.5 1.5 0 0 1 .02-.331",
    "data-name": "Path 15990"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.867 71.208a1.05 1.05 0 0 0-.214.584 5 5 0 0 0 .23 1.442 7.7 7.7 0 0 0 .5 1.324c.078.161.146.287.193.375a1 1 0 0 1 .07.138 1 1 0 0 1-.087-.124 5 5 0 0 1-.207-.365 6.8 6.8 0 0 1-.516-1.324 7 7 0 0 1-.174-.788 2.7 2.7 0 0 1-.044-.677 1.04 1.04 0 0 1 .141-.453.6.6 0 0 1 .108-.132",
    "data-name": "Path 15991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.434 74.227a1.2 1.2 0 0 1-.2-.231 1.7 1.7 0 0 1-.317-.7 1.14 1.14 0 0 1 .149-.819.8.8 0 0 1 .169-.189.2.2 0 0 1 .075-.045 1.2 1.2 0 0 0-.216.255 1.14 1.14 0 0 0-.128.78 1.9 1.9 0 0 0 .3.688 2 2 0 0 1 .166.258",
    "data-name": "Path 15992"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.512 71.555s.011.01.029.033l.074.1a.6.6 0 0 1 .087.191.8.8 0 0 1-.008.3c-.036.223-.125.479-.2.764a7 7 0 0 0-.174.939 12.4 12.4 0 0 0-.054 1.71c0 .189.009.359.014.516a1.4 1.4 0 0 1 0 .191 1.3 1.3 0 0 1-.019-.187c-.009-.121-.02-.3-.03-.513a11 11 0 0 1 .04-1.717 6.3 6.3 0 0 1 .18-.948c.079-.288.17-.54.21-.758a.58.58 0 0 0-.06-.475 1 1 0 0 1-.086-.15",
    "data-name": "Path 15993"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m59.974 96.816 3.285-7.845a.217.217 0 0 1 .284-.117l2.418 1.012a.217.217 0 0 1 .117.284l-3.285 7.846a.217.217 0 0 1-.284.117l-2.417-1.012a.217.217 0 0 1-.117-.284",
    "data-name": "Path 15994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M59.974 96.816s-.006.02-.009.06a.22.22 0 0 0 .054.158c.048.057.149.077.254.124l.368.148 1.008.411.629.258.169.07a.34.34 0 0 0 .161.044.18.18 0 0 0 .13-.078c.025-.042.05-.116.076-.174l3.209-7.708a.16.16 0 0 0-.061-.195c-.073-.036-.181-.077-.269-.115l-.553-.232-1.081-.454-.527-.221a.16.16 0 0 0-.192.037.2.2 0 0 0-.028.043l-.027.064-.054.128-.421 1-1.462 3.458-.995 2.327-.276.63-.074.163a.2.2 0 0 1-.029.054.2.2 0 0 1 .018-.059l.064-.167.255-.639.96-2.342 1.438-3.468.417-1 .053-.128.027-.065a.3.3 0 0 1 .047-.075.28.28 0 0 1 .322-.068l.527.22 1.082.452.553.231c.1.042.179.07.287.125a.28.28 0 0 1 .107.341l-3.241 7.7a2 2 0 0 1-.085.187.26.26 0 0 1-.191.112.4.4 0 0 1-.2-.052l-.168-.072-.625-.267-1-.43-.364-.158c-.1-.051-.2-.072-.258-.141a.22.22 0 0 1-.048-.175.14.14 0 0 1 .021-.058",
    "data-name": "Path 15995"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M65.65 91.015a19 19 0 0 1-2.769-1.094 19 19 0 0 1 2.769 1.094",
    "data-name": "Path 15996"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M64.493 94.045a39 39 0 0 1-2.918-1 13.5 13.5 0 0 1 2.918 1",
    "data-name": "Path 15997"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M60.17 96.396a19 19 0 0 1 2.823 1.073 19 19 0 0 1-2.823-1.073",
    "data-name": "Path 15998"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9874",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9873"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__g)",
    "data-name": "Group 9872",
    transform: "translate(34.168 84.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.508 4.253 16.754-2.52-4.423-1.734L.002 2.475Z",
    "data-name": "Path 15999"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9896"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9895"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "m108.181 21.897-4.329 1.453 4.329 12.677-6.541-6.086-4.063 8.122s9.143 6.415 12.471 6.87 5.7-1.572 5.664-5.289c-.016-1.565-7.53-17.748-7.53-17.748",
    "data-name": "Path 16000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M110.406 38.83a24 24 0 0 1-2.108-2.7 24 24 0 0 1 2.108 2.7",
    "data-name": "Path 16001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "M103.225 17.648s-1.17-1.307-1.756-1.009-1.279 1.067-1.251 1.6.283.953.513.874a4 4 0 0 0 .8-.709l1.082.911.012 1.5-.717.638-.73-.862-.094-1.163s-.684-.331-.767.64-.028 2.67 1.068 3.214a27 27 0 0 0 3.063 1.159l3.964-1.392-.262-5.024a8.9 8.9 0 0 0 1.124-2.761c-.07-.7-.512-2.775-.512-2.775a.5.5 0 0 0-.713.4 13 13 0 0 0 .023 2.367l-1.014 1.654-.979-5.987s-.951-.317-.944 1.083.481 4.746.317 4.787-.658.168-.761-.527-1.673-5.851-1.673-5.851a1.41 1.41 0 0 0-.748 1.64c.356 1.082 1.2 4.541 1.251 4.805s-.291.782-.291.782",
    "data-name": "Path 16002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M105.655 22.329c-.028.016-.131-.138-.336-.342a2.77 2.77 0 0 0-2.033-.8c-.29.009-.47.052-.479.021s.161-.114.467-.162a2.39 2.39 0 0 1 2.151.848c.191.243.251.427.231.437",
    "data-name": "Path 16003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M77.787 1.439a3.378 3.378 0 0 0-6.068 1.221 3.73 3.73 0 0 0 1.421 3.663 8.26 8.26 0 0 0 4.051 1.561l1.13-.553a5.49 5.49 0 0 0-.534-5.893",
    "data-name": "Path 16004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M77.44 10.924a.754.754 0 1 1 .891.586.755.755 0 0 1-.891-.586",
    "data-name": "Path 16005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m69.541 4.836.7 1.33 7.239 5.039.839-1.264-7.2-5-1.514-.205a.07.07 0 0 0-.068.1",
    "data-name": "Path 16006"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9879",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9878"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__h)",
    "data-name": "Group 9877",
    transform: "translate(69.538 4.739)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.584.205c-.006.072-.061.134-.125.125a.34.34 0 0 1 .005.368.36.36 0 0 1-.33.184.44.44 0 0 1-.091.376.4.4 0 0 1-.342.157L.007.104a.075.075 0 0 1 .072-.1Z",
    "data-name": "Path 16007"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M69.822 5.297c.08-.016.275-.091.325-.434a.047.047 0 0 0-.038-.057l-.507-.069a.067.067 0 0 0-.064.092l.236.445a.044.044 0 0 0 .049.022",
    "data-name": "Path 16008"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9882",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9881"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__i)",
    "data-name": "Group 9880",
    transform: "translate(70.239 5.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.433 0 7.175 4.936-.395.622L.006.543 0 .532a.3.3 0 0 0 .154-.02.46.46 0 0 0 .289-.377.4.4 0 0 0-.011-.136",
    "data-name": "Path 16009"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9885",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9884"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__j)",
    "data-name": "Group 9883",
    transform: "translate(70.997 4.943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .129 7.22 5.026.115-.149-7.21-5a.14.14 0 0 1-.1.126H0",
    "data-name": "Path 16010"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m77.437 11.175.9-1.23a.04.04 0 0 1 .054-.009l.379.276a.04.04 0 0 1 .009.054l-.9 1.23a.04.04 0 0 1-.054.009l-.379-.276a.04.04 0 0 1-.008-.054",
    "data-name": "Path 16011"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M77.436 11.175v.01a.04.04 0 0 0 0 .03c.006.012.023.02.039.032l.058.041.159.113.1.071.027.019a.1.1 0 0 0 .026.014.03.03 0 0 0 .026-.008l.02-.027.877-1.209a.03.03 0 0 0 0-.036l-.042-.031-.087-.063-.17-.124-.082-.06a.03.03 0 0 0-.035 0l-.007.006-.007.01-.015.02-.114.157-.4.541-.269.364-.074.1-.02.025-.007.008.006-.009.018-.027.071-.1.264-.368.394-.544.114-.157.015-.02.007-.01.011-.011a.05.05 0 0 1 .059 0l.083.06.169.124.087.063.045.034a.05.05 0 0 1 0 .064l-.882 1.205-.022.029a.05.05 0 0 1-.038.011.1.1 0 0 1-.032-.017l-.026-.02-.1-.072-.156-.116-.057-.043c-.015-.013-.032-.021-.039-.035a.04.04 0 0 1 0-.032l.006-.009",
    "data-name": "Path 16012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.664 10.4a2 2 0 0 1-.224-.144 1.6 1.6 0 0 1-.212-.161 2 2 0 0 1 .224.144 2 2 0 0 1 .212.161",
    "data-name": "Path 16013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.337 10.879a2 2 0 0 1-.236-.142 2 2 0 0 1-.23-.152 1.5 1.5 0 0 1 .242.134 1.5 1.5 0 0 1 .225.16",
    "data-name": "Path 16014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M77.488 11.109a3.4 3.4 0 0 1 .447.3 2 2 0 0 1-.229-.143 2 2 0 0 1-.218-.16",
    "data-name": "Path 16015"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m92.581 6.344-18.39 2.27a28.3 28.3 0 0 0-1.316 16.924 59.5 59.5 0 0 0 23.094-1.117 86.4 86.4 0 0 0-3.387-18.078",
    "data-name": "Path 16016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M74.622 7.435a10.89 10.89 0 0 1 7.4-5.824 11.7 11.7 0 0 1 4.153-.11 6.05 6.05 0 0 1 3.84 1.529 10.14 10.14 0 0 1 2.886 4.124 28.4 28.4 0 0 1 1.307 5.052 9.5 9.5 0 0 1-.594 5.125l-4.174 1.653a27.9 27.9 0 0 1-7.227 1.1 9.38 9.38 0 0 1-6.642-2.623c-2.325-2.474-2.52-7.017-.95-10.027",
    "data-name": "Path 16017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "m78.47 6.606 5.3-3.494 1.545-.139c3.4-.694 6.516 2.559 7.111 5.3a50 50 0 0 1 1.33 9.141 5.99 5.99 0 0 1-3.818 5.905l.448 4.458 1.366 1.175 2.432 9.617-6.941 2.252-5.064-13.269-.256-.517-4.656-18.563a1.64 1.64 0 0 1 1.2-1.866",
    "data-name": "Path 16018"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M86.74 17.768a.98.98 0 0 1 .209-.663 1.006 1.006 0 0 1 1.18-.317 1.35 1.35 0 0 1 .759 1.133 1.22 1.22 0 0 1-.754.676 1.4 1.4 0 0 1-.16.039 1.1 1.1 0 0 1-.785-.136.98.98 0 0 1-.448-.732",
    "data-name": "Path 16019"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M91.402 12.431a.6.6 0 0 1-.481.684.573.573 0 0 1-.692-.441.6.6 0 0 1 .48-.684.573.573 0 0 1 .692.441",
    "data-name": "Path 16020"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M91.705 10.014c-.062.088-.561-.175-1.2-.077s-1.056.488-1.137.42c-.039-.029.014-.18.2-.359a1.65 1.65 0 0 1 .9-.432 1.58 1.58 0 0 1 .968.158c.219.12.306.25.275.29",
    "data-name": "Path 16021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M88.684 15.794a4.3 4.3 0 0 1 1.007-.343c.16-.041.309-.1.32-.212a.84.84 0 0 0-.182-.466l-.669-1.165a21.6 21.6 0 0 1-1.572-3.075 21.5 21.5 0 0 1 1.816 2.941l.65 1.176a.95.95 0 0 1 .181.626.41.41 0 0 1-.232.278 1.1 1.1 0 0 1-.27.08 4.2 4.2 0 0 1-1.049.16",
    "data-name": "Path 16022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M89.94 23.314a11.9 11.9 0 0 1-6.435-.712s2.008 3.207 6.565 2.076Z",
    "data-name": "Path 16023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M86.875 16.518c.1-.022.209.669.876 1.07s1.391.214 1.411.309c.016.042-.144.159-.454.215a1.74 1.74 0 0 1-1.172-.219 1.51 1.51 0 0 1-.69-.9c-.07-.285-.019-.468.029-.471",
    "data-name": "Path 16024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M91.034 7.854c-.084.172-.587.142-1.15.276-.567.116-1.013.355-1.159.234-.066-.06-.027-.221.147-.407a1.83 1.83 0 0 1 1.861-.411c.235.1.337.226.3.308",
    "data-name": "Path 16025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M84.518 13.547a.6.6 0 0 0 .68.485.57.57 0 0 0 .506-.645.6.6 0 0 0-.68-.486.573.573 0 0 0-.506.646",
    "data-name": "Path 16026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M83.126 11.542c.088.063.471-.351 1.1-.47s1.158.11 1.212.019c.027-.041-.074-.165-.3-.274a1.65 1.65 0 0 0-.988-.11 1.58 1.58 0 0 0-.861.47c-.166.187-.206.338-.163.365",
    "data-name": "Path 16027"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M83.085 9.448c.152.12.612-.122 1.2-.24.582-.137 1.1-.11 1.189-.282.036-.082-.069-.212-.313-.306a1.85 1.85 0 0 0-1.021-.05 1.8 1.8 0 0 0-.9.471c-.18.187-.22.348-.151.408",
    "data-name": "Path 16028"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m78.602 14.915.962.655c2.734-3.976 7.7-13.54 7.432-12.975a10.16 10.16 0 0 0-4.988.486c-2.449.96-7 3.232-6.3 6.208a15.9 15.9 0 0 0 2.9 5.627",
    "data-name": "Path 16029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "M79.648 15.975c-.053-.343-.573-1.093-.921-1.095-.928 0-2.552.316-2.218 2.62.456 3.149 3.527 2.042 3.519 1.95-.006-.071-.2-2.29-.38-3.476",
    "data-name": "Path 16030"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M78.991 18.422c-.015-.008-.049.046-.136.1a.56.56 0 0 1-.409.068 1.37 1.37 0 0 1-.805-1.127 1.8 1.8 0 0 1 .04-.808.64.64 0 0 1 .352-.481.28.28 0 0 1 .346.1c.055.082.044.148.061.151s.06-.062.016-.189a.35.35 0 0 0-.153-.18.42.42 0 0 0-.315-.036.78.78 0 0 0-.5.571 1.9 1.9 0 0 0-.063.905 1.44 1.44 0 0 0 1 1.244.6.6 0 0 0 .49-.156c.086-.092.093-.165.081-.169",
    "data-name": "Path 16031"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M70.716 9.857a2.11 2.11 0 0 0 2.2.229 4.22 4.22 0 0 1-2.646 1.63 3.77 3.77 0 0 0 4.19-.887l.158-3.394a4.53 4.53 0 0 1-3.906 2.421",
    "data-name": "Path 16032"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "m67.722 59.507 4.693.518 2.765-10.443 1.088-18.055-1.586-1.551a11.33 11.33 0 0 0-5.461 7.708c-.924 4.9-1.646 10.4-1.907 11.965l-5.793-4.067-2.546 1.631s4.954 11.061 8.747 12.293",
    "data-name": "Path 16033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M100.091 59.966c-.171-1.54-.3-2.859-.361-3.611l.922-4.84c.071-.2.426-1.494.623-6.636a62.5 62.5 0 0 0-1.633-14.566s-.072-1.234-.883-1.554c-2.128-.839-6.688-1.763-6.884-1.965-1.269 2.18-4.307 4.166-10.278-.124l-7.2 1.542c-1.019.429-2.616 1.533-2.514 2.634l3.919 14.8 2.286 8.081-3.193 6.236Z",
    "data-name": "Path 16034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m102.887 42.929 4.839-8.233s-3.542-3.322-6.179-5.631c-2.9-2.542-4.285-2.245-8.19-1.409 0 0 .665 9.248 4.566 11.961.725.5 4.965 3.311 4.965 3.311",
    "data-name": "Path 16035"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9888",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9887"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__k)",
    "data-name": "Group 9886",
    transform: "translate(100.592 36.679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.516 5.229C.369 3.029 0 0 0 0s2.519 3.382 2.176 6.331",
    "data-name": "Path 16036"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M99.912 34.394a1 1 0 0 0 .036.2l.13.558c.06.241.13.537.2.884s.164.737.237 1.176.169.915.241 1.433.146 1.071.217 1.654c.121 1.168.211 2.457.232 3.813s-.044 2.647-.137 3.818c-.056.585-.1 1.141-.176 1.659s-.135 1-.206 1.439-.145.834-.208 1.181-.124.645-.178.888l-.116.561a1 1 0 0 0-.031.2 1 1 0 0 0 .059-.191l.142-.556c.062-.241.133-.538.2-.885s.16-.74.229-1.18.159-.92.223-1.44.129-1.076.189-1.663c.1-1.174.161-2.47.148-3.831s-.115-2.654-.244-3.825c-.075-.584-.14-1.141-.231-1.657s-.171-1-.26-1.434-.18-.829-.259-1.174-.156-.64-.224-.88l-.156-.552a1 1 0 0 0-.064-.19",
    "data-name": "Path 16037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "M95.968 27.061s-5.474 11.241-6.722 10.281-12.978-9.511-12.978-9.511l6.481-1.408 7.5.044a25.6 25.6 0 0 0 5.718.593",
    "data-name": "Path 16038"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M67.154 41.653s2.718-10.776 6.311-12.925c2.972-1.778 6.843 10.583 6.843 10.583l-.717 4.469Z",
    "data-name": "Path 16039"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m74.486 73.578-27.132-48.8a1.545 1.545 0 0 1 .6-2.1l10.6-5.894a1.545 1.545 0 0 1 2.1.6l27.132 48.8a1.545 1.545 0 0 1-.6 2.1l-10.6 5.894a1.545 1.545 0 0 1-2.1-.6",
    "data-name": "Path 16040"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9891",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9890"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__l)",
    "data-name": "Group 9889",
    transform: "translate(60.337 21.679)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.709 0 0 26.452l2.709 4.873 2.9-26.106Z",
    "data-name": "Path 16041"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9894",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9893"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__m)",
    "data-name": "Group 9892",
    transform: "translate(64.857 29.817)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.709 0 0 26.449l1.551 2.79L4.637 3.468Z",
    "data-name": "Path 16042"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56.311 25.774a32 32 0 0 1-3.137 1.865 32 32 0 0 1-3.24 1.68 63 63 0 0 1 6.377-3.545",
    "data-name": "Path 16043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M55.817 31.371a20.4 20.4 0 0 1-3.622 2.014 20.4 20.4 0 0 1 3.622-2.014",
    "data-name": "Path 16044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M60.831 33.905a63 63 0 0 1-6.377 3.545 63 63 0 0 1 6.377-3.545",
    "data-name": "Path 16045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M60.337 39.502a20.4 20.4 0 0 1-3.622 2.014 20.4 20.4 0 0 1 3.622-2.014",
    "data-name": "Path 16046"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M65.352 42.036a63 63 0 0 1-6.377 3.545 63 63 0 0 1 6.377-3.545",
    "data-name": "Path 16047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M64.857 47.633a20.3 20.3 0 0 1-3.622 2.014 20.4 20.4 0 0 1 3.622-2.014",
    "data-name": "Path 16048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M69.873 50.167a63 63 0 0 1-6.377 3.545 63 63 0 0 1 6.377-3.545",
    "data-name": "Path 16049"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M69.378 55.764a20.4 20.4 0 0 1-3.622 2.014 20.4 20.4 0 0 1 3.622-2.014",
    "data-name": "Path 16050"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M74.393 58.297a63 63 0 0 1-6.377 3.545 63 63 0 0 1 6.377-3.545",
    "data-name": "Path 16051"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M73.898 63.895a20.4 20.4 0 0 1-3.622 2.014 20.4 20.4 0 0 1 3.622-2.014",
    "data-name": "Path 16052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.913 66.428a63 63 0 0 1-6.377 3.545 63 63 0 0 1 6.377-3.545",
    "data-name": "Path 16053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "M62.093 44.387a.653.653 0 0 0-.841-.339 1.6 1.6 0 0 0 .53-.667.86.86 0 0 0-.1-.82.59.59 0 0 0-.769-.143.87.87 0 0 0-.794-.913 2.35 2.35 0 0 0-1.3.325 3 3 0 0 1-1.168.4 1 1 0 0 0-.193 0 2 2 0 0 0-.278.108 2.3 2.3 0 0 1-.615.135h-.139c-.123 0-.24-.031-.361-.04a.2.2 0 0 0-.078.006.5.5 0 0 0-.141.1 1.3 1.3 0 0 0-.3.333 1.2 1.2 0 0 0 .855 1.828.74.74 0 0 0-.427.791 1.03 1.03 0 0 0 .576.737c.29.144.438.037.76 0-.41.454.17 1.6.616 1.569a1.45 1.45 0 0 0 .9 1.044c.32.114 1.159-.5 1.442-.8-.1-.169-.553-1.033-.553-1.033a21 21 0 0 1 1.463-1.009 2.3 2.3 0 0 0 .766-.65 1 1 0 0 0 .129-.96",
    "data-name": "Path 16054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc09d",
    d: "M55.142 41.567a.97.97 0 0 1-.077-.806 1.6 1.6 0 0 1 .876-.65c.223.324.317.5.54.824.047.068.056.139.127.181.188.112.566-.087.783-.105a.743.743 0 0 1 .746.7 1 1 0 0 1-.569.91 1.54 1.54 0 0 1-1.108.062 2.15 2.15 0 0 1-1.319-1.111",
    "data-name": "Path 16055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M56.315 44.742a25.4 25.4 0 0 0 4.6-2.324 25.4 25.4 0 0 0-4.6 2.324",
    "data-name": "Path 16056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M57.258 46.267a10.9 10.9 0 0 0 4.083-2.244 240 240 0 0 0-4.083 2.244",
    "data-name": "Path 16057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M58.177 47.757a5.4 5.4 0 0 0 1.757-.812 7.6 7.6 0 0 0 1.586-1.1 6.8 6.8 0 0 0-1.72.878 10.7 10.7 0 0 0-1.623 1.037",
    "data-name": "Path 16058"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9b6c",
    d: "M55.532 42.002c-.029.011.008.2.228.394a1.45 1.45 0 0 0 1.047.313 2.9 2.9 0 0 0 1.043-.269c.28-.158.271-.408.231-.4-.035-.007-.085.153-.311.23a5.2 5.2 0 0 1-.978.174 1.58 1.58 0 0 1-.922-.2c-.211-.127-.3-.264-.338-.244",
    "data-name": "Path 16059"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.508 45.994h112.716v39.068H19.508z",
    "data-name": "Rectangle 3013"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9907"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9906"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m19.508 45.997 112.716-.059h.059v39.187h-.061l-112.714-.028h-.041v-.04l.041-39.068.04 39.068-.04-.041 112.716-.02-.061.061V45.99l.059.059z",
    "data-name": "Path 16060"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9899",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9898"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__n)",
    "data-name": "Group 9897",
    transform: "translate(26.292 46.048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.597 1.512-.005-.043a4 4 0 0 0 .384-.082 4 4 0 0 0-.388.05l-.06-.5a13 13 0 0 0 1.058-.94L0 .097a11.5 11.5 0 0 0 4.991 2.781l.049.351c-.4.074-.628.12-.627.127a3 3 0 0 0 .354-.045l-.252.042c.012.087.489 2.108.735 3.145a1.3 1.3 0 0 0 .176.407h-.007.009a1.23 1.23 0 0 0 .518.442l.108.049a.3.3 0 0 0 .028.05.27.27 0 0 0 .257.1l.038-.007.082.037.088-.015.135.463-.1.017a.24.24 0 0 0-.195.271v.025a.226.226 0 0 0 .262.194l.17-.029.161.551-.146.025a.24.24 0 0 0-.195.271v.025a.226.226 0 0 0 .261.194l.216-.037.066.226a1.54 1.54 0 0 0 1.041 1.069 1.4 1.4 0 0 0 .619.034l.206-.034a3 3 0 0 1 .692.466.69.69 0 0 0 .594.178l2.108-.35a.74.74 0 0 0 .546-.415 1.56 1.56 0 0 1 .506-.618c.207-.045 1.178-.3 1.3-1.21.019-.143.035-.342.049-.577a.9.9 0 0 0 .226-.118l.2-.034a.24.24 0 0 0 .195-.271v-.025a.226.226 0 0 0-.262-.194l-.327.056.017-.553a.2.2 0 0 0 .046-.036l.295-.05a.24.24 0 0 0 .2-.271v-.025a.226.226 0 0 0-.262-.194l-.259.044c0-.152.005-.3.007-.457l.458-.076.421-.382a1.33 1.33 0 0 0 .431-1.053l-.181-3.227Z",
    "data-name": "Path 16061"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M89.998 62.228a5.28 5.28 0 0 1 1.586 4.212v6.725h-3.955v-1.564q-.916 1.766-3.574 1.765a5.6 5.6 0 0 1-2.436-.491 3.6 3.6 0 0 1-1.553-1.329 3.5 3.5 0 0 1-.525-1.91 3.1 3.1 0 0 1 1.318-2.67 7 7 0 0 1 4.066-.949h2.413q-.112-1.921-2.569-1.922a5.9 5.9 0 0 0-1.765.28 4.7 4.7 0 0 0-1.52.771l-1.43-2.882a7.9 7.9 0 0 1 2.449-1.044 11.6 11.6 0 0 1 2.893-.369 6.84 6.84 0 0 1 4.6 1.374m-3.463 8.1a2 2 0 0 0 .8-1.05v-1.05h-1.825q-1.855 0-1.855 1.229a1.08 1.08 0 0 0 .425.894 1.83 1.83 0 0 0 1.162.335 2.35 2.35 0 0 0 1.3-.357",
    "data-name": "Path 16062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M105.784 62.195a5.41 5.41 0 0 1 1.374 4.044v6.926h-4.245v-6.234q0-2.48-1.988-2.48a2.27 2.27 0 0 0-1.754.715 3.07 3.07 0 0 0-.659 2.145v5.854h-4.245v-12.11h4.24v1.318a4.1 4.1 0 0 1 1.5-1.128 5.8 5.8 0 0 1 2.145-.391 4.98 4.98 0 0 1 3.631 1.341",
    "data-name": "Path 16063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M122.868 56.587v16.578h-4.044v-1.207a4.38 4.38 0 0 1-3.552 1.408 6 6 0 0 1-3.016-.771 5.57 5.57 0 0 1-2.156-2.2 7.27 7.27 0 0 1 0-6.6 5.5 5.5 0 0 1 2.156-2.178 6.1 6.1 0 0 1 3.016-.76 4.4 4.4 0 0 1 3.351 1.251v-5.519Zm-4.9 12.635a3.02 3.02 0 0 0 .715-2.134 2.97 2.97 0 0 0-.7-2.1 2.37 2.37 0 0 0-1.821-.76 2.4 2.4 0 0 0-1.832.76 2.94 2.94 0 0 0-.715 2.1 3.02 3.02 0 0 0 .715 2.134 2.536 2.536 0 0 0 3.642 0",
    "data-name": "Path 16064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M55.234 74.051c-.034 0-.061-4.153-.061-9.276s.027-9.277.061-9.277.061 4.153.061 9.277-.027 9.276-.061 9.276",
    "data-name": "Path 16065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M59.412 74.233c-.034 0-.044-4.254-.023-9.5s.065-9.5.1-9.5.044 4.253.023 9.5-.065 9.5-.1 9.5",
    "data-name": "Path 16066"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M63.791 69.083s-.007.014-.027.036-.047.056-.089.1a2 2 0 0 1-.4.312 2.67 2.67 0 0 1-1.8.321 2.36 2.36 0 0 1-1.17-.524 2.5 2.5 0 0 1-.8-1.231 4.2 4.2 0 0 1-.123-1.622 2.72 2.72 0 0 1 .7-1.595 2.5 2.5 0 0 1 .724-.529 2.6 2.6 0 0 1 .841-.226 2.74 2.74 0 0 1 1.6.3 2.44 2.44 0 0 1 1.009 1.07 3.2 3.2 0 0 1 .293 1.249 3.5 3.5 0 0 1-.343 1.807 2.1 2.1 0 0 1-.284.416 1 1 0 0 1-.09.1q-.031.031-.034.029a3.05 3.05 0 0 0 .665-2.343 3.1 3.1 0 0 0-.3-1.209 2.35 2.35 0 0 0-.972-1.016 2.64 2.64 0 0 0-1.531-.276 2.5 2.5 0 0 0-.8.217 2.4 2.4 0 0 0-.688.5 2.6 2.6 0 0 0-.667 1.525 4.1 4.1 0 0 0 .112 1.576 2.4 2.4 0 0 0 .761 1.186 2.3 2.3 0 0 0 1.119.516 2.66 2.66 0 0 0 1.763-.277 3.6 3.6 0 0 0 .537-.4",
    "data-name": "Path 16067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M65.858 61.59s-.037-.015-.107-.05-.174-.086-.313-.148a6 6 0 0 0-1.275-.4 6.8 6.8 0 0 0-2.126-.069 5 5 0 0 0-1.291.341 4 4 0 0 0-1.239.839l-.067.067v-.095c0-1.572-.007-3.406-.011-5.435l.05.049-4.245.005.055-.055c0 3.759 0 8.033.006 12.548v3.78l-.06-.06h4.178l-.058.058v-1.346l.1.12a3.64 3.64 0 0 0 1.728 1.143 6 6 0 0 0 2.008.218 5.65 5.65 0 0 0 5.283-4.1 7.5 7.5 0 0 0 .24-2.864 6.2 6.2 0 0 0-.657-2.243 5.8 5.8 0 0 0-1.032-1.411 5.6 5.6 0 0 0-.849-.692c-.1-.068-.185-.119-.24-.151s-.081-.052-.081-.052a4 4 0 0 1 .331.187 5.3 5.3 0 0 1 .865.682 5.8 5.8 0 0 1 1.054 1.412 6.2 6.2 0 0 1 .679 2.262 7.6 7.6 0 0 1-.229 2.9 5.74 5.74 0 0 1-5.36 4.182 6.1 6.1 0 0 1-2.047-.219 3.8 3.8 0 0 1-.969-.451 4 4 0 0 1-.815-.724l.1-.037v1.247h-4.297v-3.84c0-4.515 0-8.789.006-12.548v-.055h.055l4.245.005h.05v.049c0 2.029-.007 3.863-.011 5.435l-.067-.028a4 4 0 0 1 1.268-.848 5 5 0 0 1 1.311-.337 6.7 6.7 0 0 1 2.142.088 5.8 5.8 0 0 1 1.276.422 4 4 0 0 1 .411.218",
    "data-name": "Path 16068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M76.495 61.067s-.042.022-.126.06-.207.1-.363.185a3.9 3.9 0 0 0-1.177 1.011l-.047.061v-.077c0-.424 0-.911-.007-1.452l.034.034-4.044.013.047-.047c0 3.287.009 7.5.014 12.11l-.061-.061h4.044l-.06.06v-5.493a3.4 3.4 0 0 1 .071-.733 3.1 3.1 0 0 1 .6-1.279 2.65 2.65 0 0 1 1.049-.833 3.4 3.4 0 0 1 1.234-.262 5 5 0 0 1 .6.024l.574.042-.048.043.015-3.821.028.028a7 7 0 0 0-1.785.2c-.2.051-.346.1-.444.132l-.15.049a4 4 0 0 1 .586-.209 6.8 6.8 0 0 1 1.793-.233h.028v.028c0 .987.009 2.27.015 3.821v.046h-.049l-.568-.038a5 5 0 0 0-.589-.021 3.3 3.3 0 0 0-1.2.259 2.55 2.55 0 0 0-1.007.806 3 3 0 0 0-.578 1.237 7.6 7.6 0 0 0-.065 1.453v4.811h-4.165v-.061l.014-12.11v-.047h.047l4.044.013h.034v.034c0 .541-.005 1.028-.007 1.452l-.048-.017a3.8 3.8 0 0 1 1.206-1 3 3 0 0 1 .5-.221",
    "data-name": "Path 16069"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.762 73.589c-.034 0-.061-3.155-.061-7.047s.027-7.047.061-7.047.061 3.154.061 7.047-.027 7.047-.061 7.047",
    "data-name": "Path 16070"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.806 73.674c-.034 0-.061-3.155-.061-7.047s.027-7.047.061-7.047.061 3.154.061 7.047-.027 7.047-.061 7.047",
    "data-name": "Path 16071"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M78.868 59.972c.034 0 .061 1.128.061 2.518s-.027 2.518-.061 2.518-.061-1.127-.061-2.518.027-2.518.061-2.518",
    "data-name": "Path 16072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M91.568 60.653c.034 0 .061 2.81.061 6.275s-.027 6.276-.061 6.276-.061-2.809-.061-6.276.027-6.275.061-6.275",
    "data-name": "Path 16073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M94.204 60.653c.034 0 .061 2.81.061 6.275s-.027 6.276-.061 6.276-.061-2.809-.061-6.276.027-6.275.061-6.275",
    "data-name": "Path 16074"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M98.506 60.653c.034 0 .061 2.81.061 6.275s-.027 6.276-.061 6.276-.061-2.809-.061-6.276.027-6.275.061-6.275",
    "data-name": "Path 16075"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M107.172 65.325c.034 0 .061 1.764.061 3.939s-.027 3.94-.061 3.94-.061-1.764-.061-3.94.027-3.939.061-3.939",
    "data-name": "Path 16076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M102.848 66.052c.034 0 .061 1.6.061 3.575s-.027 3.575-.061 3.575-.061-1.6-.061-3.575.027-3.575.061-3.575",
    "data-name": "Path 16077"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M79.445 73.353c-.034 0-.061-1.342-.061-3s.027-3 .061-3 .061 1.342.061 3-.027 3-.061 3",
    "data-name": "Path 16078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M118.82 73.165a1 1 0 0 1-.013-.168c0-.123-.007-.283-.012-.483l-.03-1.776-.106-5.86a370 370 0 0 1-.07-5.863c0-.75 0-1.357.009-1.777 0-.2.008-.361.01-.483a.085.085 0 1 1 .025 0q.002.184.013.483l.03 1.776.106 5.861c.041 2.283.069 4.361.07 5.861 0 .75 0 1.357-.009 1.777 0 .2-.008.361-.01.483a1 1 0 0 1-.012.168",
    "data-name": "Path 16079"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M122.895 73.165c-.034 0-.068-3.711-.076-8.289s.012-8.289.046-8.29.068 3.711.076 8.289-.012 8.289-.046 8.289",
    "data-name": "Path 16080"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.863 62.043a3.5 3.5 0 1 1 .4-.513 1.8 1.8 0 0 1-.4.513",
    "data-name": "Path 16081"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.822 62.566a7.6 7.6 0 0 1 1.046-1.615 7.6 7.6 0 0 1-1.046 1.615",
    "data-name": "Path 16082"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.822 63.045a13.3 13.3 0 0 1 1.382-2.132 13.2 13.2 0 0 1-1.378 2.128",
    "data-name": "Path 16083"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.859 63.587a19.7 19.7 0 0 1 1.678-2.591 19.6 19.6 0 0 1-1.678 2.591",
    "data-name": "Path 16084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.897 64.129a27 27 0 0 1 1.975-3.05 27 27 0 0 1-1.975 3.05",
    "data-name": "Path 16085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.896 64.729a39 39 0 0 1 2.333-3.65 39 39 0 0 1-2.333 3.65",
    "data-name": "Path 16086"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.924 65.285c-.028-.018.541-.959 1.272-2.1s1.346-2.055 1.375-2.037-.541.959-1.272 2.1-1.346 2.055-1.374 2.037",
    "data-name": "Path 16087"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.915 65.829c-.028-.018.62-1.082 1.449-2.375s1.523-2.328 1.551-2.309-.62 1.081-1.449 2.375-1.523 2.327-1.551 2.309",
    "data-name": "Path 16088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.93 66.413c-.028-.018.678-1.2 1.578-2.636s1.653-2.589 1.682-2.572-.678 1.2-1.579 2.636-1.653 2.589-1.682 2.571",
    "data-name": "Path 16089"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.923 67.083c-.028-.018.748-1.314 1.733-2.895s1.808-2.849 1.837-2.831-.747 1.314-1.734 2.9-1.808 2.849-1.837 2.831",
    "data-name": "Path 16090"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.916 67.696c-.029-.018.768-1.331 1.779-2.933s1.854-2.886 1.882-2.868-.768 1.331-1.78 2.933-1.854 2.886-1.882 2.868",
    "data-name": "Path 16091"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.916 68.3c-.028-.018.769-1.315 1.78-2.9s1.854-2.85 1.882-2.832-.768 1.315-1.78 2.9-1.854 2.849-1.882 2.831",
    "data-name": "Path 16092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.925 68.88c-.028-.018.741-1.259 1.717-2.771s1.791-2.724 1.82-2.706-.741 1.259-1.717 2.772-1.791 2.724-1.819 2.705",
    "data-name": "Path 16093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.931 69.472c-.028-.018.748-1.27 1.732-2.8s1.807-2.748 1.835-2.729-.747 1.269-1.733 2.8-1.806 2.747-1.835 2.729",
    "data-name": "Path 16094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.931 70.069c-.028-.018.756-1.283 1.751-2.824s1.825-2.777 1.854-2.758-.756 1.282-1.751 2.824-1.825 2.776-1.853 2.758",
    "data-name": "Path 16095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.893 70.625c-.028-.018.74-1.229 1.714-2.7s1.788-2.655 1.816-2.636-.74 1.229-1.715 2.7-1.788 2.654-1.816 2.636",
    "data-name": "Path 16096"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.936 64.083a24 24 0 0 1 1.859-2.878 24 24 0 0 1-1.859 2.878",
    "data-name": "Path 16097"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.9 63.478a12.6 12.6 0 0 1 1.339-2.074 12.6 12.6 0 0 1-1.339 2.074",
    "data-name": "Path 16098"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.931 62.809a3.923 3.923 0 1 1 .424-.545 2 2 0 0 1-.424.545",
    "data-name": "Path 16099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.943 64.672a36 36 0 0 1 2.278-3.527 36 36 0 0 1-2.278 3.527",
    "data-name": "Path 16100"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.943 65.272c-.028-.018.578-1.008 1.355-2.21s1.429-2.162 1.457-2.144-.578 1.007-1.355 2.21-1.428 2.162-1.457 2.144",
    "data-name": "Path 16101"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.905 65.907c-.028-.018.676-1.133 1.573-2.489s1.647-2.441 1.675-2.422-.676 1.133-1.573 2.489-1.647 2.44-1.675 2.422",
    "data-name": "Path 16102"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M76.178 64.641a42 42 0 0 1 2.5-3.787 42 42 0 0 1-2.5 3.787",
    "data-name": "Path 16103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M76.752 64.425a27 27 0 0 1 2.007-3.034 27 27 0 0 1-2.007 3.034",
    "data-name": "Path 16104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M77.221 64.335a15 15 0 0 1 1.482-2.241 15 15 0 0 1-1.482 2.241",
    "data-name": "Path 16105"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M77.792 64.145a5.5 5.5 0 0 1 .854-1.386 5.5 5.5 0 0 1-.854 1.386",
    "data-name": "Path 16106"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M78.153 64.176c-.028-.019.074-.224.217-.468s.294-.425.322-.406-.074.224-.217.468-.294.425-.322.406",
    "data-name": "Path 16107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.894 71.191c-.028-.019.748-1.233 1.733-2.713s1.807-2.664 1.835-2.645-.748 1.233-1.734 2.713-1.806 2.664-1.835 2.645",
    "data-name": "Path 16108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.893 71.808c-.028-.018.757-1.251 1.752-2.753s1.826-2.7 1.854-2.686-.757 1.251-1.752 2.753-1.825 2.7-1.853 2.686",
    "data-name": "Path 16109"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M70.893 72.407c-.028-.018.731-1.226 1.7-2.7s1.769-2.648 1.8-2.629-.731 1.225-1.7 2.7-1.769 2.647-1.8 2.629",
    "data-name": "Path 16110"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M71.108 72.794c-.028-.018.691-1.19 1.606-2.617s1.681-2.57 1.709-2.551-.691 1.19-1.606 2.617-1.681 2.569-1.709 2.551",
    "data-name": "Path 16111"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M71.496 72.793c-.029-.018.612-1.069 1.431-2.346s1.505-2.3 1.534-2.281-.612 1.068-1.431 2.346-1.505 2.3-1.533 2.28",
    "data-name": "Path 16112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M71.93 72.709a47 47 0 0 1 2.546-4.02 47 47 0 0 1-2.546 4.02",
    "data-name": "Path 16113"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M72.257 72.792a37 37 0 0 1 2.256-3.562 37 37 0 0 1-2.256 3.562",
    "data-name": "Path 16114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M72.714 72.709a24 24 0 0 1 1.862-2.877 24 24 0 0 1-1.862 2.877",
    "data-name": "Path 16115"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M73.073 72.778a17 17 0 0 1 1.568-2.421 17 17 0 0 1-1.568 2.421",
    "data-name": "Path 16116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M73.446 72.819a9.6 9.6 0 0 1 1.17-1.808 9.6 9.6 0 0 1-1.17 1.808",
    "data-name": "Path 16117"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M73.809 72.869a5 5 0 0 1 .842-1.3 5 5 0 0 1-.842 1.3",
    "data-name": "Path 16118"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M74.168 72.878c-.028-.018.046-.184.167-.369s.24-.321.268-.3-.046.184-.167.369-.24.321-.268.3",
    "data-name": "Path 16119"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M118.275 60.857c0 .034-13.154.061-29.376.061s-29.379-.027-29.379-.061 13.151-.061 29.379-.061 29.376.027 29.376.061",
    "data-name": "Path 16120"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M118.275 73.204c0 .034-13.154.061-29.376.061s-29.379-.027-29.379-.061 13.151-.061 29.379-.061 29.376.027 29.376.061",
    "data-name": "Path 16121"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9902",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9901"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__o)",
    "data-name": "Group 9900",
    transform: "translate(30.041 76.174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.814 0h12.3a2.255 2.255 0 0 1 2.255 2.255v6.663H0v-7.1A1.814 1.814 0 0 1 1.814.004",
    "data-name": "Path 16122"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#374a5a",
    d: "m93.957 74.497 12.712 13.5a.67.67 0 0 0 .941.01l.865-.814a.667.667 0 0 0 .048-.939L95.785 72.729c-.245-.261-.459-.056-.731.2l-.865.814c-.272.256-.478.494-.232.755",
    "data-name": "Path 16123"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e04c56",
    d: "m100.927 81.893 5.724 6.084a.68.68 0 0 0 .959.029l.865-.814a.68.68 0 0 0 .029-.959l-5.724-6.084Z",
    "data-name": "Path 16124"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#233862",
    d: "M79.463 73.372a10.863 10.863 0 1 0 .469-15.356l-.17.164a10.86 10.86 0 0 0-.3 15.191m.932-14.863a10.19 10.19 0 1 1-.439 14.4 10.14 10.14 0 0 1 .439-14.4",
    "data-name": "Path 16125"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9905",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9904"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__p)",
    "data-name": "Group 9903",
    transform: "translate(77.188 55.742)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#aaaaad",
    d: "M2.768 17.162a10.192 10.192 0 1 0 .439-14.4 10.14 10.14 0 0 0-.439 14.4",
    "data-name": "Path 16126"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9909"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9908"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M77.243 80.931a6 6 0 0 1 1.439-.616l.3-1.4 2.407-.041.346 1.391a6 6 0 0 1 1.461.566l1.217-.785 1.732 1.646-.754 1.224a5.8 5.8 0 0 1 .626 1.417l1.425.292.042 2.369-1.413.341a5.8 5.8 0 0 1-.575 1.437l.8 1.2-1.672 1.7-1.244-.742a6 6 0 0 1-1.44.616l-.3 1.4-2.407.042-.346-1.391a6 6 0 0 1-1.461-.566l-1.217.785-1.732-1.646.754-1.224a5.8 5.8 0 0 1-.626-1.417l-1.425-.292-.042-2.369 1.414-.341a5.8 5.8 0 0 1 .575-1.437l-.8-1.2 1.672-1.7Zm1.531 2.933a2.52 2.52 0 0 0 .073 4.033 2.61 2.61 0 0 0 3.146-.055 2.52 2.52 0 0 0-.073-4.033 2.61 2.61 0 0 0-3.146.056",
    "data-name": "Path 16127"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M78.774 83.864a2 2 0 0 1 .53-.349 2.65 2.65 0 0 1 1.707-.174 2.58 2.58 0 0 1 1.921 3.186 2.62 2.62 0 0 1-2.433 1.924 2.67 2.67 0 0 1-1.477-.372 2.7 2.7 0 0 1-.954-1 2.5 2.5 0 0 1-.309-1.161 2.55 2.55 0 0 1 .551-1.623 2.4 2.4 0 0 1 .332-.334 1 1 0 0 1 .13-.1 1 1 0 0 1-.114.118 3 3 0 0 0-.311.345 2.55 2.55 0 0 0-.5 1.592 2.45 2.45 0 0 0 .311 1.115 2.6 2.6 0 0 0 .922.949 2.57 2.57 0 0 0 1.414.35 2.51 2.51 0 0 0 2.324-1.836 2.514 2.514 0 0 0-1.826-3.071 2.66 2.66 0 0 0-1.668.133 5 5 0 0 0-.549.305",
    "data-name": "Path 16128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M77.245 80.93s-.027-.013-.08-.043l-.238-.137-.936-.546h.024l-1.664 1.713v-.039l.8 1.2.012.018-.011.019a5.8 5.8 0 0 0-.567 1.43l-.006.023-.024.006-1.413.344.033-.043.047 2.369-.038-.046 1.425.29.03.006.009.029a5.7 5.7 0 0 0 .622 1.4l.017.027-.017.028-.753 1.225-.009-.068 1.734 1.644-.07-.007 1.216-.786.029-.019.03.017a6 6 0 0 0 1.447.559l.035.008.009.034.347 1.391-.059-.045 2.407-.043-.058.048.3-1.4.008-.036.035-.01a6 6 0 0 0 1.424-.609l.032-.018.031.018 1.244.742-.074.01 1.672-1.7-.007.076-.8-1.2-.02-.031.018-.032a5.7 5.7 0 0 0 .57-1.422l.009-.035.035-.008 1.414-.34-.044.057-.04-2.369.045.054-1.424-.293-.032-.007-.009-.032a5.7 5.7 0 0 0-.618-1.4l-.017-.028.017-.028.756-1.223.008.063-1.729-1.649.057.005-1.218.782-.022.014-.023-.013a6 6 0 0 0-1.449-.565l-.024-.006-.006-.023-.342-1.392.036.027-2.408.033.026-.021-.3 1.4v.012h-.011a6 6 0 0 0-1.1.418c-.117.057-.2.1-.259.134s-.086.044-.086.044.027-.02.081-.053.139-.083.255-.143a5.8 5.8 0 0 1 1.1-.438l-.014.015.289-1.4v-.021h.022l2.407-.05h.029l.007.028.35 1.39-.029-.029a6 6 0 0 1 1.472.566h-.045l1.215-.788.031-.02.027.025 1.735 1.643.03.028-.021.035-.752 1.225v-.055a5.8 5.8 0 0 1 .633 1.43l-.041-.038 1.425.29.044.009v.045l.044 2.369v.046l-.045.011-1.413.342.043-.043a5.8 5.8 0 0 1-.58 1.453v-.062l.8 1.2.027.041-.034.035-1.672 1.705-.033.034-.041-.024-1.244-.742h.061a6 6 0 0 1-1.453.621l.043-.046-.3 1.4-.01.047h-.048l-2.407.041h-.047l-.011-.046-.346-1.391.043.043a6 6 0 0 1-1.474-.572h.059l-1.217.784-.038.024-.032-.031-1.73-1.648-.032-.03.023-.037.756-1.223v.055a5.8 5.8 0 0 1-.629-1.431l.038.035-1.424-.294-.038-.008v-.038l-.038-2.369v-.035l.034-.008 1.414-.338-.029.029a5.8 5.8 0 0 1 .582-1.445v.037l-.793-1.2-.014-.021.017-.018 1.68-1.7.011-.011.013.008.918.56.236.146q.08.051.08.053",
    "data-name": "Path 16129"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9911"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9910"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.644 67.109a6.847 6.847 0 1 1 6.9-6.794 6.847 6.847 0 0 1-6.9 6.794",
    "data-name": "Path 16130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M16.644 67.109s.038 0 .111-.009l.325-.018.239-.012c.088-.009.183-.027.286-.041l.334-.05a4 4 0 0 0 .374-.087 6.5 6.5 0 0 0 1.822-.744 6.8 6.8 0 0 0 1.947-1.719l.222-.293c.069-.1.132-.212.2-.319s.14-.213.194-.331l.173-.352.087-.179.07-.188.143-.382c.044-.13.073-.266.11-.4a4 4 0 0 0 .1-.411 6 6 0 0 0 .106-.86c.006-.147.022-.294.021-.444s-.013-.3-.02-.451c0-.075 0-.152-.013-.227l-.033-.227c-.024-.152-.041-.306-.071-.458a7 7 0 0 0-.259-.91 7 7 0 0 0-.383-.891c-.077-.144-.166-.283-.25-.426-.044-.07-.081-.145-.131-.211l-.148-.2a6.2 6.2 0 0 0-1.433-1.45l-.208-.158-.223-.139-.224-.139a2 2 0 0 0-.231-.128l-.478-.235-.5-.188a6.74 6.74 0 0 0-4.301-.039l-.505.18-.482.227-.12.057-.114.068-.226.135-.225.135-.211.155a6.2 6.2 0 0 0-1.456 1.427l-.152.2c-.051.066-.089.14-.135.209-.085.142-.177.279-.256.422a7 7 0 0 0-.4.885 7 7 0 0 0-.274.905c-.033.152-.052.306-.078.457l-.037.227c-.011.075-.011.152-.016.227l-.027.45c0 .149.01.3.014.444a6 6 0 0 0 .093.862 4 4 0 0 0 .09.413c.036.135.062.272.1.4l.137.385.067.189.084.181.167.355c.053.118.128.223.19.334s.127.218.194.322l.217.3a6.8 6.8 0 0 0 1.92 1.749 6.5 6.5 0 0 0 1.81.772 4 4 0 0 0 .372.092l.333.055c.1.016.2.036.286.046l.239.016.325.023q.11.01.111.011h-.111l-.326-.014-.24-.012c-.088-.008-.183-.027-.287-.041l-.335-.052a4 4 0 0 1-.375-.089 6.5 6.5 0 0 1-1.827-.763 6.8 6.8 0 0 1-1.945-1.754l-.22-.3c-.068-.1-.131-.215-.2-.324s-.139-.217-.193-.336l-.17-.358-.085-.182-.069-.191-.139-.388c-.043-.132-.071-.269-.107-.406a4 4 0 0 1-.092-.417 6 6 0 0 1-.1-.871c0-.148-.018-.3-.015-.449s.017-.3.026-.456c.006-.076.006-.154.016-.23l.037-.23c.026-.153.045-.309.078-.463a7 7 0 0 1 .275-.917 7 7 0 0 1 .4-.9c.08-.145.173-.284.259-.427.046-.07.085-.145.136-.212l.153-.2a6.3 6.3 0 0 1 1.473-1.447l.213-.157.228-.137.229-.137.115-.069.121-.058.488-.23.512-.183a6.82 6.82 0 0 1 4.35.034l.509.191.484.238a2 2 0 0 1 .234.13l.227.141.226.141.211.16a8 8 0 0 1 .793.682 8 8 0 0 1 .657.788l.15.2c.05.067.088.143.133.214.084.145.175.285.252.431a7.5 7.5 0 0 1 .647 1.823c.03.155.047.311.071.464l.033.23c.009.077.008.154.013.23l.019.456c0 .151-.015.3-.022.449a6.4 6.4 0 0 1-.11.869 4 4 0 0 1-.1.416c-.039.136-.068.273-.113.4l-.145.386-.072.19-.088.181-.175.355c-.055.119-.133.223-.2.333s-.132.218-.2.321l-.225.295a6.8 6.8 0 0 1-1.972 1.724 6.5 6.5 0 0 1-1.839.735 4 4 0 0 1-.377.083l-.336.046c-.1.013-.2.03-.288.037l-.24.008-.326.01h-.111",
    "data-name": "Path 16131"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M17.292 60.195a1.68 1.68 0 0 0 1.014-1.548 1.58 1.58 0 1 0-3.154-.039 1.68 1.68 0 0 0 .993 1.579c-2.43.346-2.341 2.986-2.341 2.986l5.74.071s.152-2.666-2.251-3.048",
    "data-name": "Path 16132"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9913"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9912"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.957 93.185H29.116a1.89 1.89 0 0 1-1.892-1.892V78.93a1.89 1.89 0 0 1 1.892-1.891h12.841a1.89 1.89 0 0 1 1.892 1.891v12.361a1.89 1.89 0 0 1-1.892 1.892",
    "data-name": "Path 16133"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M42.454 93.183a1.5 1.5 0 0 0 .615-.154 1.4 1.4 0 0 0 .738-.971 3 3 0 0 0 .025-.561c0-1.6-.008-3.911-.014-6.766 0-1.428 0-2.993-.006-4.672v-1.281a3 3 0 0 0-.039-.645 1.35 1.35 0 0 0-.813-.955 1.6 1.6 0 0 0-.657-.1H28.616a1.36 1.36 0 0 0-1.241.816 1.4 1.4 0 0 0-.1.376c-.013.127-.01.262-.01.4v12.956a3 3 0 0 0 .011.327 1.4 1.4 0 0 0 .219.593 1.36 1.36 0 0 0 1.044.6l4.67.01 6.765.014 1.839.008h.641-.641l-1.839.008-6.765.014h-4.674a1.44 1.44 0 0 1-1.1-.627 1.5 1.5 0 0 1-.233-.626 3 3 0 0 1-.012-.336V78.655c0-.133 0-.267.011-.407a1.5 1.5 0 0 1 .106-.4 1.45 1.45 0 0 1 1.323-.871h13.687a1.7 1.7 0 0 1 .687.106 1.43 1.43 0 0 1 .859 1.012 3 3 0 0 1 .036.662v1.281c0 1.679 0 3.244-.006 4.672l-.014 6.766a3 3 0 0 1-.029.567 1.4 1.4 0 0 1-1.219 1.114 2 2 0 0 1-.163.006",
    "data-name": "Path 16134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M30.903 80.843h9.065l.015 3.036h-.434a2.76 2.76 0 0 0-1.22-2.2 3.76 3.76 0 0 0-1.691-.346v7.931a1.53 1.53 0 0 0 .29 1.1 1.87 1.87 0 0 0 1.209.272v.382H32.77v-.382a1.77 1.77 0 0 0 1.173-.276 1.53 1.53 0 0 0 .29-1.1v-7.931a3.86 3.86 0 0 0-1.691.346 2.56 2.56 0 0 0-1.22 2.2h-.434Z",
    "data-name": "Path 16135"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9948"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9947"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m127.919 83.805 31.444-9.742a1.746 1.746 0 0 1 2.184 1.151l2.516 8.121a1.745 1.745 0 0 1-1.151 2.184l-31.444 9.742a1.745 1.745 0 0 1-2.184-1.151l-2.516-8.121a1.745 1.745 0 0 1 1.151-2.184",
    "data-name": "Path 16136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m129.285 94.111.029.056a2 2 0 0 0 .07.166 1.66 1.66 0 0 0 .426.558 1.73 1.73 0 0 0 1.041.428 1.9 1.9 0 0 0 .718-.106l.8-.253 9.6-2.989c4.051-1.262 8.877-2.759 14.233-4.428l4.116-1.278q1.053-.319 2.125-.659a2.8 2.8 0 0 0 1.011-.436 1.7 1.7 0 0 0 .634-1.466 2.5 2.5 0 0 0-.128-.551l-.346-1.106-.7-2.243-1.421-4.58a1.7 1.7 0 0 0-1.807-1.185 3 3 0 0 0-.571.145l-.568.176-1.133.362-4.448 1.378-8.412 2.6c-5.365 1.647-10.188 3.149-14.245 4.4q-.758.236-1.483.458l-.714.22a2.1 2.1 0 0 0-.655.284 1.72 1.72 0 0 0-.7 1.773c.049.207.123.413.183.615l1.271 4.132.8 2.607.206.682.066.232-.075-.229-.215-.677-.818-2.602-1.288-4.128c-.061-.2-.133-.4-.185-.618a1.78 1.78 0 0 1 .722-1.838 2.1 2.1 0 0 1 .671-.3l.713-.222 1.483-.462c4.053-1.259 8.878-2.757 14.235-4.429 2.68-.831 5.485-1.709 8.409-2.607l4.449-1.38 1.136-.351q.283-.09.568-.176a3 3 0 0 1 .584-.145 1.8 1.8 0 0 1 1.179.274 1.84 1.84 0 0 1 .735.975l1.419 4.581.707 2.257.346 1.106a2.5 2.5 0 0 1 .134.57 1.8 1.8 0 0 1-.672 1.554 1.7 1.7 0 0 1-.512.286c-.185.066-.36.114-.54.171q-1.074.33-2.13.65-2.1.655-4.111 1.274a18410 18410 0 0 1-23.85 7.358l-.8.248a1.9 1.9 0 0 1-.731.1 1.75 1.75 0 0 1-1.052-.442 1.6 1.6 0 0 1-.421-.57 1.3 1.3 0 0 1-.067-.169Z",
    "data-name": "Path 16137"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m153.531 76.374 5.399-1.673 3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m145.886 78.743 5.399-1.673 3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m138.239 81.111 5.399-1.673 3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m130.595 83.479 5.399-1.673 3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3024"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9916",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9915"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__q)",
    "data-name": "Group 9914",
    transform: "translate(153.531 74.702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.672 5.399-.001l3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3025"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9919",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9918"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__q)",
    "data-name": "Group 9917",
    transform: "translate(145.886 77.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.672 5.399-.001l3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3027"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9922",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9921"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__q)",
    "data-name": "Group 9920",
    transform: "translate(138.239 79.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.673 5.399 0l3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3029"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9925",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9924"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__q)",
    "data-name": "Group 9923",
    transform: "translate(130.595 81.807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.672 5.399-.001l3.264 10.536-5.399 1.673z",
    "data-name": "Rectangle 3031"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m131.833 94.842-6.474-5.326a1.8 1.8 0 0 1-.255-2.536l20.822-25.346a1.8 1.8 0 0 1 2.538-.25l6.475 5.327a1.8 1.8 0 0 1 .25 2.538l-20.826 25.35a1.8 1.8 0 0 1-2.533.243",
    "data-name": "Path 16138"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m131.831 94.842.051.035a1 1 0 0 0 .149.1 1.7 1.7 0 0 0 .664.232 1.8 1.8 0 0 0 1.113-.183 4 4 0 0 0 1.091-1.111c1.5-1.836 3.675-4.491 6.363-7.769s5.889-7.182 9.444-11.514l2.724-3.318q.7-.85 1.411-1.718a3 3 0 0 0 .611-.917 1.76 1.76 0 0 0 .021-1.088 1.8 1.8 0 0 0-.634-.9l-.894-.736-1.812-1.488-3.7-3.039a1.75 1.75 0 0 0-2.176-.046 2.4 2.4 0 0 0-.414.423l-.382.465q-.385.462-.754.916l-2.952 3.6c-1.938 2.357-3.805 4.63-5.586 6.8l-9.462 11.5-.986 1.2q-.24.29-.474.577a2.2 2.2 0 0 0-.393.593 1.76 1.76 0 0 0-.021 1.332 1.7 1.7 0 0 0 .343.551 5 5 0 0 0 .478.422l3.333 2.747 2.1 1.74.544.455c.124.1.185.157.185.157s-.066-.048-.19-.148l-.551-.447-2.117-1.725-3.343-2.735a5 5 0 0 1-.486-.426 1.8 1.8 0 0 1-.356-.568 1.83 1.83 0 0 1 .016-1.38 2.3 2.3 0 0 1 .4-.613l.473-.575.984-1.2c2.708-3.288 5.905-7.186 9.461-11.512q2.677-3.257 5.581-6.8 1.448-1.775 2.951-3.6.375-.455.753-.917l.384-.464a2.5 2.5 0 0 1 .424-.436 1.85 1.85 0 0 1 2.3.045l3.7 3.041 1.813 1.488.894.736a1.9 1.9 0 0 1 .665.948 1.85 1.85 0 0 1-.023 1.151 1.7 1.7 0 0 1-.274.508c-.115.153-.237.292-.354.439q-.715.866-1.413 1.717l-2.733 3.325-9.459 11.5c-2.7 3.265-4.877 5.917-6.381 7.745l-.533.648a1.81 1.81 0 0 1-1.7.643 1.7 1.7 0 0 1-.674-.247 1.5 1.5 0 0 1-.2-.143",
    "data-name": "Path 16139"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m142.363 66.728 3.587-4.368 8.524 7.001-3.588 4.368z",
    "data-name": "Rectangle 3033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m137.282 72.914 3.587-4.368 8.524 7.001-3.588 4.368z",
    "data-name": "Rectangle 3034"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m132.201 79.1 3.587-4.368 8.524 7.001-3.588 4.368z",
    "data-name": "Rectangle 3035"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m127.122 85.284 3.587-4.368 8.524 7.001-3.588 4.368z",
    "data-name": "Rectangle 3036"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9928",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9927"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__r)",
    "data-name": "Group 9926",
    transform: "translate(142.363 62.361)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4.367 3.587-.001 12.111 7l-3.588 4.368z",
    "data-name": "Rectangle 3037"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9931",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9930"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__r)",
    "data-name": "Group 9929",
    transform: "translate(137.282 68.546)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4.367 3.587-.001 12.111 7l-3.588 4.368z",
    "data-name": "Rectangle 3039"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9934",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9933"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__s)",
    "data-name": "Group 9932",
    transform: "translate(132.201 74.732)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4.367 3.587-.001 12.111 7l-3.588 4.368z",
    "data-name": "Rectangle 3041"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9937",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9936"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__s)",
    "data-name": "Group 9935",
    transform: "translate(127.122 80.916)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 4.367 3.587-.001 12.111 7l-3.588 4.368z",
    "data-name": "Rectangle 3043"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "m131.671 58.164 8.4 1.874a1.67 1.67 0 0 1 1.267 1.994l-7.172 32.14a1.67 1.67 0 0 1-1.994 1.267l-8.4-1.874a1.67 1.67 0 0 1-1.267-1.994l7.172-32.14a1.67 1.67 0 0 1 1.994-1.267",
    "data-name": "Path 16140"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M132.322 95.62a2 2 0 0 0 .242.027 1.6 1.6 0 0 0 .7-.1 1.66 1.66 0 0 0 .86-.725 2 2 0 0 0 .232-.692l.18-.821 2.163-9.83 3.219-14.575.931-4.212.482-2.176c.038-.183.087-.368.116-.549a1.62 1.62 0 0 0-1.021-1.771 4 4 0 0 0-.552-.143l-1.135-.255-2.29-.51-4.691-1.042a1.64 1.64 0 0 0-1.138.172 1.6 1.6 0 0 0-.742.868 6 6 0 0 0-.144.574l-.128.583-.256 1.159-1.013 4.557-1.911 8.606-3.24 14.573-.337 1.517c-.057.247-.109.49-.164.73a1.9 1.9 0 0 0-.067.71 1.65 1.65 0 0 0 .665 1.15 2.9 2.9 0 0 0 1.217.412l4.22.94 2.669.6.7.163.232.054s-.081-.014-.238-.049l-.7-.148-2.675-.583-4.234-.927-.628-.14a1.7 1.7 0 0 1-.612-.277 1.72 1.72 0 0 1-.693-1.193 2 2 0 0 1 .066-.732l.176-.731.339-1.519 3.216-14.575c.609-2.742 1.243-5.62 1.906-8.607l1.008-4.553.257-1.159.129-.584a6 6 0 0 1 .148-.588 1.7 1.7 0 0 1 .788-.923 1.74 1.74 0 0 1 1.213-.169l4.687 1.045 2.29.51 1.133.251a4 4 0 0 1 .557.131 1.7 1.7 0 0 1 .507.3 1.76 1.76 0 0 1 .571 1 1.7 1.7 0 0 1 0 .585c-.033.192-.08.37-.118.556l-.483 2.174-.941 4.218-3.224 14.564-2.194 9.821-.185.821a4 4 0 0 1-.091.372l-.067.17q-.038.08-.081.156a1.7 1.7 0 0 1-.88.729 1.6 1.6 0 0 1-.7.092 1 1 0 0 1-.18-.025Z",
    "data-name": "Path 16141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m128.869 65.757 1.22-5.516 10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m127.138 73.57 1.22-5.516 10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3046"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m125.406 81.384 1.22-5.516 10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "m123.675 89.199 1.22-5.516 10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3048"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9940",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9939"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__t)",
    "data-name": "Group 9938",
    transform: "translate(127.138 68.052)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 5.518 1.22.002l10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3049"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9943",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9942"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__u)",
    "data-name": "Group 9941",
    transform: "translate(125.406 75.866)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 5.518 1.22.002l10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3051"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9946",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9945"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__t)",
    "data-name": "Group 9944",
    transform: "translate(123.675 83.681)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 5.518 1.22.002l10.766 2.382-1.22 5.516z",
    "data-name": "Rectangle 3053"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M133.402 93.787a1.328 1.328 0 1 1-.625-1.77 1.326 1.326 0 0 1 .626 1.767",
    "data-name": "Path 16142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M133.401 93.788a2 2 0 0 0 .084-.313 1.34 1.34 0 0 0-.134-.847 1.29 1.29 0 0 0-1.021-.685 1.26 1.26 0 0 0-.727.148 1.27 1.27 0 0 0-.648 1.366 1.26 1.26 0 0 0 .341.659 1.29 1.29 0 0 0 1.163.374 1.3 1.3 0 0 0 .743-.429c.137-.157.183-.266.193-.262a.3.3 0 0 1-.031.08 1 1 0 0 1-.131.209 1.34 1.34 0 0 1-.76.474 1.36 1.36 0 0 1-1.254-.371 1.35 1.35 0 0 1-.375-.712 1.37 1.37 0 0 1 .7-1.469 1.35 1.35 0 0 1 .783-.153 1.37 1.37 0 0 1 .674.262 1.35 1.35 0 0 1 .4.483 1.32 1.32 0 0 1 .108.888 1 1 0 0 1-.081.232q-.028.072-.031.068",
    "data-name": "Path 16143"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9950"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9949"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fafafa",
    d: "M139.949 51.937s7.793-9.479 16.938-.138c0 0-7.523 9.8-16.938.138",
    "data-name": "Path 16144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M139.948 51.937a1 1 0 0 1 .078.07l.218.2.348.328c.135.131.292.279.485.435l.626.53.784.581c.288.2.607.394.942.606l.538.29q.137.075.281.149l.3.132a9.5 9.5 0 0 0 2.746.807 8.9 8.9 0 0 0 3.269-.188 12.3 12.3 0 0 0 6.23-4.055l.048-.06v.08a17 17 0 0 0-3.018-2.463 10.9 10.9 0 0 0-3.324-1.411 8.9 8.9 0 0 0-3.259-.141 10.3 10.3 0 0 0-2.741.788 13.6 13.6 0 0 0-3.465 2.255c-.367.325-.637.595-.817.78l-.2.213a1 1 0 0 1-.07.072.6.6 0 0 1 .061-.08q.063-.078.194-.222c.174-.191.439-.467.8-.8a13.3 13.3 0 0 1 3.462-2.3 10.3 10.3 0 0 1 2.762-.81 9 9 0 0 1 3.3.131 11 11 0 0 1 3.362 1.419 17 17 0 0 1 3.041 2.478l.038.038-.033.041-.05.062a12.36 12.36 0 0 1-6.3 4.088 8.9 8.9 0 0 1-3.309.179 9.5 9.5 0 0 1-2.768-.829l-.3-.135c-.1-.047-.189-.1-.282-.152l-.539-.3c-.336-.215-.654-.415-.942-.617l-.781-.591-.622-.539a7 7 0 0 1-.483-.45l-.342-.341-.207-.208a1 1 0 0 1-.066-.071",
    "data-name": "Path 16145"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M151.356 51.939a2.938 2.938 0 1 1-2.938-2.938 2.94 2.94 0 0 1 2.938 2.938",
    "data-name": "Path 16146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M149.611 51.939a1.193 1.193 0 1 1-1.193-1.193 1.193 1.193 0 0 1 1.193 1.193",
    "data-name": "Path 16147"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9958"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9957"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M138.443 43.627a10.144 10.144 0 1 1-10.145-10.148 10.144 10.144 0 0 1 10.144 10.144",
    "data-name": "Path 16148"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9953",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9952"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__v)",
    "data-name": "Group 9951",
    transform: "translate(118.154 33.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.289 10.144A10.144 10.144 0 1 1 10.144-.004 10.144 10.144 0 0 1 20.288 10.14",
    "data-name": "Path 16149"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M138.443 42.506a10.144 10.144 0 1 1-10.145-10.148 10.144 10.144 0 0 1 10.144 10.144",
    "data-name": "Path 16150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M135.094 42.506a6.795 6.795 0 1 1-6.8-6.795 6.8 6.8 0 0 1 6.8 6.795",
    "data-name": "Path 16151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M131.621 42.506a3.325 3.325 0 1 1-3.325-3.325 3.325 3.325 0 0 1 3.325 3.325",
    "data-name": "Path 16152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m135.369 35.08-.276-2.164 2.2-2.358.159 2.335Z",
    "data-name": "Path 16153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m140.097 33.358-2.235-.182-2.24 2.155 2.241.24Z",
    "data-name": "Path 16154"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9956",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9955"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__w)",
    "data-name": "Group 9954",
    transform: "translate(128.742 35.351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.004 7.106 7.757-5.922A9.5 9.5 0 0 0 6.79-.001L.004 6.578Z",
    "data-name": "Path 16155"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m137.546 32.567-3.158 3.159-5.01 5.011-1.152 1.152c-.365.365.205.928.57.563l3.158-3.159 5.01-5.011 1.152-1.152a.4.4 0 0 0-.57-.563",
    "data-name": "Path 16156"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9972"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__b)",
    "data-name": "Group 9971"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M43.48 35.207a11.827 11.827 0 0 0-13.647-10.186 12.58 12.58 0 0 0-10.259 14.141 11.92 11.92 0 0 0 8.391 9.871l.427 3.069 10.476-1.733s-.177-1.733-.367-3.274a12.68 12.68 0 0 0 4.978-11.887",
    "data-name": "Path 16157"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.43 51.341c-.61-3.936-.961-7.916-1.643-11.84a29 29 0 0 0-.49-2.362 3.27 3.27 0 0 0-1.624-2.445 1.53 1.53 0 0 0-1.352.058 1.97 1.97 0 0 0-.812 1.105 5.1 5.1 0 0 0 .017 2.978 5.29 5.29 0 0 0 4.021 3.789 5.51 5.51 0 0 0 5.328-1.989 5.7 5.7 0 0 0 .7-5.862c-.414-.775-1.249-1.581-2.2-1.314-.923.259-1.242 1.28-1.328 2.145a18.5 18.5 0 0 0 .07 3.03 90 90 0 0 0 .312 3.478c.253 2.383.561 4.758.813 7.142q.083.79.155 1.581c.016.178.284.123.269-.055-.379-4.228-1.059-8.42-1.309-12.663a12.6 12.6 0 0 1 .011-2.854 2.2 2.2 0 0 1 .588-1.265 1.19 1.19 0 0 1 1.315-.187 3.12 3.12 0 0 1 1.486 2.474 5.63 5.63 0 0 1-.384 2.948 5.2 5.2 0 0 1-4.558 3.2 4.9 4.9 0 0 1-4.623-2.671 5.4 5.4 0 0 1-.613-2.736c.047-.949.436-2.338 1.63-2.172 1.144.159 1.575 1.394 1.83 2.382.177.685.312 1.382.437 2.079.648 3.632 1.008 7.316 1.522 10.971q.078.555.163 1.108c.027.177.3.122.269-.055",
    "data-name": "Path 16158"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M31.955 56.948a3.2 3.2 0 0 1 .77.5.69.69 0 0 0 .594.177l2.108-.35a.74.74 0 0 0 .546-.415 1.4 1.4 0 0 1 .641-.69Z",
    "data-name": "Path 16159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M28.837 51.355c.006.043.964 3.312 1.33 4.563a1.54 1.54 0 0 0 1.041 1.069 1.4 1.4 0 0 0 .619.034l4.61-.767s1.2-.2 1.342-1.218c.144-1.072.125-5.188.125-5.188Z",
    "data-name": "Path 16160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m38.253 54.306-8.367 1.422a.226.226 0 0 1-.262-.194v-.025a.24.24 0 0 1 .195-.271l8.368-1.421a.226.226 0 0 1 .262.194v.025a.24.24 0 0 1-.195.271",
    "data-name": "Path 16161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "m38.213 53.232-8.584 1.458a.226.226 0 0 1-.262-.194v-.025a.24.24 0 0 1 .195-.271l8.584-1.458a.226.226 0 0 1 .262.193v.025a.24.24 0 0 1-.195.271",
    "data-name": "Path 16162"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "m38.24 52.147-8.932 1.517a.226.226 0 0 1-.262-.193v-.026a.24.24 0 0 1 .195-.271l8.933-1.517a.226.226 0 0 1 .262.193v.026a.24.24 0 0 1-.195.271",
    "data-name": "Path 16163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M38.24 52.148a.26.26 0 0 0 .155-.115.27.27 0 0 0 .012-.228.214.214 0 0 0-.253-.129l-2.071.365-6.839 1.174a.2.2 0 0 0-.154.133.25.25 0 0 0 .031.206.19.19 0 0 0 .183.072l.245-.042.961-.162 1.817-.306 3.077-.514 2.075-.34.565-.088.147-.021a.2.2 0 0 1 .05 0 .2.2 0 0 1-.05.012l-.146.029-.563.1-2.071.365-3.074.531-1.816.311-.961.164-.245.042a.26.26 0 0 1-.257-.1.3.3 0 0 1-.053-.135.3.3 0 0 1 .01-.146.28.28 0 0 1 .216-.187l6.842-1.151 2.075-.339a.24.24 0 0 1 .28.15.28.28 0 0 1-.021.246.24.24 0 0 1-.118.1.2.2 0 0 1-.05.01",
    "data-name": "Path 16164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455a64",
    d: "M27.491 49.507c.012.087.489 2.108.735 3.145a1.24 1.24 0 0 0 .7.852l.513.231 8.914-1.482.421-.382a1.33 1.33 0 0 0 .431-1.053l-.181-3.227Z",
    "data-name": "Path 16165"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9961",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9960"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__x)",
    "data-name": "Group 9959",
    transform: "translate(30.032 54.326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.35a13.4 13.4 0 0 0 2.894-.266C3.714.944 4.521.832 5.41.667 6.06.546 6.657.415 7.304.28A1.9 1.9 0 0 0 8.039 0Z",
    "data-name": "Path 16166"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9964",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9963"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__x)",
    "data-name": "Group 9962",
    transform: "translate(29.886 53.279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.001 1.35a13.4 13.4 0 0 0 2.894-.266C3.715.944 4.522.832 5.41.666 6.061.545 6.657.414 7.304.279a1.9 1.9 0 0 0 .735-.28Z",
    "data-name": "Path 16167"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M39.045 51.291c0 .022-2.379.436-5.319.925s-5.328.868-5.331.846 2.378-.436 5.32-.925 5.327-.867 5.33-.845",
    "data-name": "Path 16168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M38.949 47.541c0 .024-2.581.484-5.773 1.028s-5.785.965-5.789.941 2.58-.484 5.773-1.028 5.784-.965 5.788-.941",
    "data-name": "Path 16169"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9967",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9966"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__y)",
    "data-name": "Group 9965",
    transform: "translate(27.916 26.063)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.017 2.923a2.1 2.1 0 0 1 .6-1.61A3.6 3.6 0 0 1 3.03.066a8.29 8.29 0 0 1 6.873 2.113 5.2 5.2 0 0 1 1.772 2.873 1.93 1.93 0 0 1-.42 1.441c-.878 1.03-2.392.546-3.356-.237-.9-.73-1.674-1.714-2.793-2a11 11 0 0 0-2.853.057C1.297 4.324.185 3.884.021 2.926",
    "data-name": "Path 16170"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9970",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9969"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#brand_svg__z)",
    "data-name": "Group 9968",
    transform: "translate(38.788 33.76)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.015 1.464A1.846 1.846 0 0 1 1.709.002 1.78 1.78 0 0 1 3.068.84a1.75 1.75 0 0 1-.119 1.916 1.59 1.59 0 0 1-1.807.505 1.94 1.94 0 0 1-1.128-1.8",
    "data-name": "Path 16171"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M23.43 26.095c-.024.024-.872-.786-1.894-1.808s-1.832-1.871-1.809-1.895.872.786 1.895 1.809 1.832 1.871 1.808 1.894",
    "data-name": "Path 16172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M29.476 23.394a1.1 1.1 0 0 1-.088-.253c-.05-.165-.115-.406-.192-.7a40 40 0 0 1-.902-4.725 19 19 0 0 1-.081-.725 1.1 1.1 0 0 1-.011-.268 1.2 1.2 0 0 1 .058.262l.119.719c.1.607.24 1.445.415 2.366s.354 1.751.485 2.352l.154.712a1.1 1.1 0 0 1 .042.265",
    "data-name": "Path 16173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M37.444 19.11a3.8 3.8 0 0 1-.122.707 23 23 0 0 1-1.007 3.308 3.7 3.7 0 0 1-.293.654 5 5 0 0 1 .212-.684c.142-.418.334-1 .531-1.641s.358-1.232.474-1.658a5 5 0 0 1 .205-.686",
    "data-name": "Path 16174"
  }))))))));
};
export default SvgBrand;